

























































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import cancelOrderOption from '@/table/delivery/cancelOrder';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';

import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import getDeliveries from '@/gql/delivery/getDeliveries.gql';
import deleteDelivery from '@/gql/delivery/deleteDelivery.gql';
import countDelivery from '@/gql/delivery/countDelivery.gql';

const CancelOrder = defineComponent({
  setup() {
    const { me } = useAuth();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();
    const filter = reactive({
      text: '',
      orderDate: {
        from: undefined,
        to: undefined,
      },
    });
    function clickDateHandler(date: any) {
      if (filter.orderDate.from === useFormat.date(date).computerShortDate()) {
        filter.orderDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.orderDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }
    const ordersVariable = computed(() => {
      const vars: {[key: string]: any} = {
        searchCustomerName: undefined,
        filterByStatus: 'CANCEL',
        filterOrderDateBetween: undefined,
      };
      if (filter.text) {
        vars.searchCustomerName = `%${filter.text}%`;
      }
      if (filter.orderDate.from) {
        vars.filterOrderDateBetween = filter.orderDate;
      }
      return vars;
    });
    const getOrdersResult = (data: any) => data.deliveries;
    const { router } = useRouter();
    const onRowClick = (row: any) => {
      router.push({ name: 'DeliveryInformation', params: { id: row.item.id } });
    };

    // ==============================================
    // ===== Use to delete Delivery from system =====
    // ==============================================
    const refetchQueriesList = [
      'getDeliveries', 'countDelivery',
    ];
    const deleteDeliveryModal = ref(null);
    const deleteDeliveryMutation = useMutation(deleteDelivery, {
      refetchQueries: refetchQueriesList,
    });
    function deleteDeliveryAction(deliveryId: number) {
      deleteDeliveryMutation.mutate({
        id: deliveryId,
      });
    }

    // count delivery to display on top panel
    const totalCancelOrder = ref(0);
    const { result: getCountDeliveryResult, loading: countDeliveryLoading } = useQuery(countDelivery, () => ({
      filterOrderDateBetween: filter.orderDate.from ? filter.orderDate : undefined,
    }), () => ({
      fetchPolicy: 'cache-and-network',
    }));
    const countDeliveryResult = useResult(getCountDeliveryResult, [
      { status: 'CANCEL', count: 0 },
    ], (data) => data.countDelivery);
    watch(() => countDeliveryResult.value, (newVal, oldVal) => {
      if (!countDeliveryLoading.value && newVal !== oldVal) {
        totalCancelOrder.value = countDeliveryResult.value.find((countObj: any) => countObj.status === 'CANCEL')?.count || 0;
      }
    });

    return {
      me,
      distanceTypeToChipClass,
      translateDistanceType,

      filter,
      clickDateHandler,
      cancelOrderOption,
      getDeliveries,
      ordersVariable,
      getOrdersResult,
      onRowClick,

      deleteDeliveryModal,
      deleteDeliveryMutation,
      deleteDeliveryAction,

      totalCancelOrder,
    };
  },
  components: {
    CommonModalWithPreset,
    CommonDeliveryStatusSelect,
  },
});

export default CancelOrder;
